<div class="menu-logo" (click)="goHome()">
  <div class="image-logo">
    <img src="../../assets/logo-bal.png" />
  </div>
  <h1>Grupo BAL</h1>
</div>
<mat-list>
  <mat-divider></mat-divider>
  <button mat-button [routerLink]="['/agenda']" (click)="changeTema('ALL')">
    <mat-icon>view_day</mat-icon>Día
  </button>
  <mat-divider></mat-divider>

  @if (catTemasLectura.includes('-KcOsYIkmr2FHgi4ubym')) {
  <button
    mat-button
    (click)="changeTema('-KcOsYIkmr2FHgi4ubym')"
    [disabled]="statusMenu">
    <mat-icon class="naranja">group_work</mat-icon>Corporativo
  </button>
  } @if (catTemasLectura.includes('-KcOsYIoTX3wdcK4DMjF')) {
  <button
    mat-button
    (click)="changeTema('-KcOsYIoTX3wdcK4DMjF')"
    [disabled]="statusMenu">
    <mat-icon class="rojo">group_work</mat-icon>Corporativo Confidencial
  </button>
  } @if (catTemasLectura.includes('-KcOsYIprL1TVCF2uyaO')) {
  <button
    mat-button
    (click)="changeTema('-KcOsYIprL1TVCF2uyaO')"
    [disabled]="statusMenu">
    <mat-icon class="azul">group_work</mat-icon>Personal
  </button>
  } @if (catTemasLectura.includes('-KdfegAIz9pHjb6ak32K')) {
  <button
    mat-button
    (click)="changeTema('-KdfegAIz9pHjb6ak32K')"
    [disabled]="statusMenu">
    <mat-icon class="verde">group_work</mat-icon>Personal Confidencial
  </button>
  }
  <mat-divider></mat-divider>

  @if (isAdministrador) {
  <button mat-button (click)="showCatalogos = !showCatalogos">
    <mat-icon>list</mat-icon>Administración catálogos
  </button>
  } @if (showCatalogos) {
  <button [routerLink]="'administracion/catalogos/empresa'" mat-button>
    <mat-icon>list</mat-icon>Empresa
  </button>
  <button [routerLink]="'administracion/catalogos/modo-entrada'" mat-button>
    <mat-icon>list</mat-icon>Modo de entrada
  </button>
  <button [routerLink]="'administracion/catalogos/remitentes'" class="btn-remitente" mat-button>
    <mat-icon >list</mat-icon>Remitentes y Destinatarios
  </button>
  <button [routerLink]="'administracion/catalogos/tipo'" mat-button>
    <mat-icon>list</mat-icon>Tipo
  </button>
  <button [routerLink]="'administracion/catalogos/usuarios'" mat-button>
    <mat-icon>list</mat-icon>Usuarios
  </button>
  }
  <mat-divider></mat-divider>
  <button mat-button (click)="showFE = !showFE">
    <div
      style="
        display: flex;
        justify-content: space-between;
        width: 100%;
        align-items: center;
        gap: 1rem;
      ">
      <mat-icon style="flex-grow: 1; margin-right: auto">send</mat-icon>
      <span style="flex-grow: 1; text-align: center">Forma de Envío</span>
      <mat-icon style="flex-grow: 1; margin-left: auto">
        {{ showFE ? "keyboard_arrow_up" : "keyboard_arrow_down" }}
      </mat-icon>
    </div>
  </button>

  @if (showFE) {
  <button
    [routerLink]="'acuerdos-mrb-listado'"
    mat-button
    class="custom-badge-button"
    *ngIf="contador$ | async as contador">
    <mat-icon></mat-icon>
    <div class="!flex" style="height: auto; align-items: center">
      <span class="label !mt-4">Acuerdo Mr. B.</span>
      <span class="badge">
        {{ contador.acuerdo || 0 }}
      </span>
    </div>
  </button>

  <button
    [routerLink]="'despacho/listado'"
    mat-button
    class="custom-badge-button"
    *ngIf="contador$ | async as contador">
    <mat-icon></mat-icon>
    <div class="!flex" style="height: auto; align-items: center">
      <span class="label !mt-4">Despacho</span>
      <span class="badge">
        {{ contador.despacho || 0 }}
      </span>
    </div>
  </button>

  }
  <mat-divider></mat-divider>
  <button [routerLink]="'bandeja'" mat-button>
    <mat-icon>inbox</mat-icon>Bandeja de entrada
  </button>
  <mat-divider></mat-divider>
  <button [routerLink]="'tablero'" mat-button>
    <mat-icon>dns</mat-icon>Tablero de seguimiento
  </button>
  <mat-divider></mat-divider>
  <button [routerLink]="'reportes'" mat-button>
    <mat-icon>assignment</mat-icon>Reportes
  </button>
  <mat-divider></mat-divider>
  @if (isCoordnador) {
  <button [routerLink]="'administracion/catalogos/usuarios'" mat-button>
    <mat-icon>list</mat-icon>Usuarios
  </button>
  <mat-divider></mat-divider>
  }
  <button mat-button (click)="openTutorial()">
    <mat-icon>help</mat-icon>Tutorial
  </button>
  <button mat-button (click)="openManual()">
    <mat-icon>description</mat-icon>Manual de Usuarios
  </button>
  <button mat-button (click)="openBottomPerfil()">
    <mat-icon>contacts</mat-icon>Perfil
  </button>
  <mat-divider></mat-divider>
  
  <!--button mat-button (click)="regresarSO()" class="btn-back-so">
    <mat-icon>replay</mat-icon>Versión Anterior
  </button-->
</mat-list>
